export default __webpack_public_path__ + "static/media/danger.ac67f76a.svg";